(function () {
    'use strict';

    angular
        .module('app')
        .controller('DocumentTemplateTestMerge', DocumentTemplateTestMerge);

    DocumentTemplateTestMerge.$inject = ['$q', 'entityTemplateId', 'EntitiesService', 'EntityTemplatesService', 'DialogService', 'DialogInstance'];

    /**
     * @ngdoc controller
     * @name DocumentTemplateTestMerge
     *
     * @description
     * Dialog for selecting which entity to perform a test document template merge against.
     *    **Does not actually perform a merge**
     * When used inside an mdDialog, returns the chosen entity ID when the dialog is confirmed
     * with the 'OK' button.
     *
     * @param {number} entityTemplateId - The entity template to filter entity selection by.
     */
    function DocumentTemplateTestMerge($q, entityTemplateId, EntitiesService, EntityTemplatesService, DialogService, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.entityTemplateId = angular.copy(entityTemplateId);
        vm.entityTemplate = {};
        vm.entities = [];
        vm.ok = ok;
        vm.cancel = cancel;
        
        activate();

        function activate() {
            var promises = [loadEntityTemplate(), loadEntities()];

            $q.all(promises).catch(function error(response) {
                DialogService.error('Error fetching test merge options', response);
            });
        }

        function loadEntityTemplate() {
            return EntityTemplatesService.get(vm.entityTemplateId)
                .then(function ok(entityTemplate) {
                    vm.entityTemplate = entityTemplate;
                });
        }

        function loadEntities() {
            return EntitiesService.query({ entityTemplateId: vm.entityTemplateId, })
                .then(function ok(data) {
                    vm.entities = data.Entities;
                });
        }

        function ok() {
            DialogInstance.ok(vm.entityId);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
